import {
  CasLoaderWithBackdrop,
  CasErrorDisplay,
  CasReactHookFormDialog,
} from 'src/compass/shared/components';
import { onSuccessEnqueueSnackbar } from 'src/compass/shared/util/onSuccessEnqueueSnackbar';
import useUpdateMutation from 'src/compass/shared/hooks/reactQuery/useUpdateMutation';
import { useRetrieveDetailsById } from 'src/compass/shared/hooks/reactQuery/useRetrieveDetailsById';
import AccountForm from './AccountForm';
import { AccountSchema } from './AccountSchema';

type AccountDialogProps = {
  id: number;
  onClose: VoidFunction;
}

export default function AccountDialog({ id, onClose }: AccountDialogProps) {
  const { data, isFetching, isError } = useRetrieveDetailsById({
    entity: `Utilities/EntityAccount`,
    id,
    enabled: !!id,
  });

  const mutation = useUpdateMutation({
    url: 'Utilities/EntityAccount',
    onSuccess: (successData) => {
      onSuccessEnqueueSnackbar(successData);
      onClose();
    },
  });

  const { mutate, isPending } = mutation;

  const saveEntity = (entityData: any) => {
    const { entityObj, ...rest } = entityData;
    mutate({ ...rest, entityId: entityObj.id });
  };

  if (isFetching) return <CasLoaderWithBackdrop />;

  if (isError) return <CasErrorDisplay message="Error retrieving data from the server." />;

  return (
    <CasReactHookFormDialog
      open
      onClose={onClose}
      title="Edit Account"
      submitButtonLabel="Update"
      defaultValues={data}
      onSubmit={saveEntity}
      schema={AccountSchema}
    >
      {isPending && <CasLoaderWithBackdrop />}
      <AccountForm row={data} />
    </CasReactHookFormDialog>
  );
}
